import React from 'react';
// template components
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// native components
import AdvisorConnectCardSimplified from '../../../../components/advisorConnectCardSimplified';

export default () => {
  return (
    <AdvisorConnectCardSimplified
      id='estate-planning'
      backgroundVariant='lightB'
      headingText={<>Ready to start your <WidowBlock>estate plan&#63;</WidowBlock></>}
      text='Our financial advisors will help with your estate planning and show you how it fits into your bigger financial plan.'
    />
  );
};
